import { Action, ActionFunctionAny, createAction } from 'redux-actions'

import { TConstantMap } from './constants'

export type ReduxAction = ActionFunctionAny<Action<any>>
export interface IActionsMap {
  request: ReduxAction
  receive: ReduxAction
  setFilter: ReduxAction
  applyFilter: ReduxAction
  saveUi: ReduxAction
  setFilterMode: ReduxAction
  setIncluded: ReduxAction
  clearFilters: ReduxAction
  setSort: ReduxAction
  applyLocalFilter: ReduxAction
  setItems: ReduxAction
  applyLocalFulltextfilter: ReduxAction
  applyLocalSort: ReduxAction
  sortLocal: ReduxAction
  applyLocalValueFilter: ReduxAction
  setLoading: ReduxAction
  setGrouping: ReduxAction
  setRequestId: ReduxAction
  setCustomHeaders: ReduxAction
  setCustomPayload: ReduxAction
}

export function generateActions(constants: TConstantMap): IActionsMap {
  return {
    request: createAction(constants.REQUEST),
    receive: createAction(constants.RECEIVE),
    setFilter: createAction(constants.SET_FILTER),
    applyFilter: createAction(constants.APPLY_FILTER),
    saveUi: createAction(constants.SAVE_UI),
    setFilterMode: createAction(constants.SET_FILTER_MODE),
    setIncluded: createAction(constants.SET_INCLUDED),
    clearFilters: createAction(constants.CLEAR_FILTERS),
    setSort: createAction(constants.SET_SORT),
    applyLocalFilter: createAction(constants.APPLY_LOCAL_FILTER),
    setItems: createAction(constants.SET_ITEMS),
    applyLocalFulltextfilter: createAction(
      constants.APPLY_LOCAL_FULLTEXTFILTER,
    ),
    applyLocalSort: createAction(constants.APPLY_LOCAL_SORT),
    sortLocal: createAction(constants.SORT_LOCAL),
    applyLocalValueFilter: createAction(constants.APPLY_LOCAL_VALUEFILTER),
    setLoading: createAction(constants.SET_LOADING),
    setGrouping: createAction(constants.SET_GROUPING),
    setRequestId: createAction(constants.SET_REQUEST_ID),
    setCustomHeaders: createAction(constants.SET_CUSTOM_HEADERS),
    setCustomPayload: createAction(constants.SET_CUSTOM_PAYLOAD),
  }
}
